module.exports = __webpack_public_path__ + "img/instagram-icon.7500f181.svg";